import React from 'react';

const CaseCategoriesListLoading = () => {
  return <div></div>;
};

export default CaseCategoriesListLoading;
